var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 233.5,-0.5 C 248.167,-0.5 262.833,-0.5 277.5,-0.5C 377.766,12.0408 449.266,64.0408 492,155.5C 502.296,180.684 508.796,206.684 511.5,233.5C 511.5,248.167 511.5,262.833 511.5,277.5C 498.959,377.766 446.959,449.266 355.5,492C 330.316,502.296 304.316,508.796 277.5,511.5C 262.833,511.5 248.167,511.5 233.5,511.5C 133.234,498.959 61.734,446.959 19,355.5C 8.70393,330.316 2.20393,304.316 -0.5,277.5C -0.5,262.833 -0.5,248.167 -0.5,233.5C 12.0408,133.234 64.0408,61.734 155.5,19C 180.684,8.70393 206.684,2.20393 233.5,-0.5 Z M 243.5,27.5 C 324.326,26.2427 389.493,57.2427 439,120.5C 488.353,192.387 496.353,268.72 463,349.5C 429.171,418.652 374.671,461.819 299.5,479C 214.496,492.555 142.662,468.055 84,405.5C 27.4074,335.955 13.7407,258.622 43,173.5C 75.1026,97.7347 131.269,50.568 211.5,32C 222.268,30.1562 232.935,28.6562 243.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 165.5,170.5 C 186.091,168.763 197.758,178.097 200.5,198.5C 196.095,221.709 182.429,230.209 159.5,224C 143.309,213.061 139.809,198.894 149,181.5C 153.632,176.34 159.132,172.673 165.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 336.5,170.5 C 357.115,168.791 368.781,178.124 371.5,198.5C 368.922,218.584 357.589,227.751 337.5,226C 323.464,221.94 315.797,212.607 314.5,198C 315.801,183.879 323.134,174.712 336.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 143.5,309.5 C 144.675,309.281 145.675,309.614 146.5,310.5C 180.596,357.043 226.263,375.543 283.5,366C 318.093,357.388 345.593,338.554 366,309.5C 374.248,313.927 382.081,318.927 389.5,324.5C 361.257,366.974 321.59,391.141 270.5,397C 214.186,400.463 167.686,380.963 131,338.5C 127.586,334.006 124.419,329.34 121.5,324.5C 128.851,319.474 136.185,314.474 143.5,309.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.f8ad9d82.svg";
export { ForwardRef as ReactComponent };